export default {

  namespaced: true,

  state: () => ({

    accountResume: {
      sumBillReceivebleTotal:{}
    },
    shift: null,
    accountTransaction: null,

  }),

  mutations: {
    setAccountResume(state, data) {
      state.accountResume = data
    },
    setAccountTransaction(state, data) {
      state.accountTransaction = data
    },
    selectedShift(state, data) {
      state.shift = data
    }
  },

  getters: {
    openingBalance(state) {
      try {
        return state.accountResume.openingBalance.openingBalance
      } catch (error) {
        return 0
      }
    },

    totalIn(state) {
      try {
        return state.accountResume.sumByOrigin.filter((row) => row.type == 'i' && row.origin != 'dd' && row.origin != 't').reduce((sum, row) => {
          return sum + parseFloat(row.sum_value)
        }, 0);
      } catch (error) {
        return 0
      }
    },

    totalOut(state) {
      try {
        return state.accountResume.sumByOrigin.filter((row) => row.type == 'o' && row.origin != 'dd' && row.origin != 't').reduce((sum, row) => {
          return sum + parseFloat(row.sum_value)
        }, 0);
      } catch (error) {
        return 0
      }
    },

    closingBalance(state) {
      try {
        return state.accountResume.closingBalance.closingBalance
      } catch (error) {
        return 0
      }
    },

    getSumByOriginAndType: (state) => (origin, type) => {
      try {
        return state.accountResume.sumByOrigin.filter((row) => row.origin == origin && row.type == type)[0].sum_value
      } catch (error) {
        return 0
      }
    },

    orderSum: (state) => {
      try {
        return state.accountResume.sumOrderByPaymentMethod.reduce((sum, row) => {
          return sum + parseFloat(row.sum_value)
        }, 0);
      } catch (error) {
        return 0
      }
    },
    billReceivebleSum: (state) => {
      return state.accountResume.sumBillReceivebleTotal.sum_value
    },

    getOrderSumByPaymentMethod: (state) => (paymentMethod) => {
      try {
        let arr = state.accountResume.sumOrderByPaymentMethod.filter((row) => row.payment_method == paymentMethod)[0]
        return arr.sum_value
      } catch (error) {
        return 0
      }
    },

    totalTransfer(state) {
      try {
        return state.accountResume.sumByOrigin.filter((row) => row.origin == 't').reduce((sum, row) => {
          return sum + parseFloat(row.sum_value)
        }, 0);
      } catch (error) {
        return 0
      }
    },

    totalDiference(state) {
      try {
        return state.accountResume.sumByOrigin.filter((row) => row.origin == 'dd').reduce((sum, row) => {
          return sum + parseFloat(row.sum_value)
        }, 0);
      } catch (error) {
        return 0
      }
    },
  },


  actions: {

    //'drawer/drawer-transactions'
    async getDrawerTransactions({ commit }, params) {

      const response = await axios.get("/erp/account/drawer-account-transaction", { params: params })

      commit('setAccountTransaction', response.data)

      return response

    },

    async getDrawerResume({ commit }, params) {
      const response = await axios.get("/erp/account/drawer-resume", { params: params })

      commit('setAccountResume', response.data)

      return response
    },

    async getShifts({ commit }, params) {
      const shifts = await axios.get("/erp/account/shift", { params: params })

      return shifts.data
    },

    async postStartShift({ commit }, { account_id }) {
      await axios.post("/erp/account/start-shift", { account_id: account_id })
        .then(response => {


        }).catch(error => {

        });
    },

    async postEndShift({ commit }, { account_id }) {
      await axios.post("/erp/account/end-shift", { account_id: account_id })
        .then(response => {


        }).catch(error => {

        });
    },

    async postReopenShift({ commit }, { account_id, shift_id }) {
      await axios.post("/erp/account/reopen-shift", { account_id, shift_id });
    },

    async postEndShiftDifferenceTransaction({ commit }, params) {
      await axios.post("/erp/account/drawer-difference-shift", params)
        .then(response => {

          console.log(response)

        }).catch(error => {

        });
    },

  }
}
